<template>
  <div id="evaluation-section-wrapper" ref="evaluationWrapper">
    <h3 class="evaluation-section-title txt-bold">Valoración</h3>
    <div class="evaluation-gohome-container">
      <button
        class="evaluation-gohome-btn txt-grad-color-2 txt-bold"
        @click="goHome"
        v-if="!result.show"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="bi bi-arrow-left"
          width="18"
          height="18"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop
              offset="0%"
              style="stop-color: rgb(0, 246, 187); stop-opacity: 1"
            />
            <stop
              offset="100%"
              style="stop-color: rgb(29, 143, 206); stop-opacity: 1"
            />
          </linearGradient>
          <path
            fill="url(#grad2)"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
        Volver al inicio
      </button>
    </div>
    <form
      class="evaluation-section-form"
      autocomplete="off"
      @submit.prevent="confirmEvaluateForm"
    >
      <p class="evaluation-form-title">
        Por favor digita la
        <span class="txt-bold">valoración</span> correspondiente a cada uno de
        los momentos de aprendizaje de la plantilla
        <span
          class="txt-bold txt-grad-color-2"
          v-if="frmPlantilla.nombre_plantilla"
          >"{{ frmPlantilla.nombre_plantilla }}"</span
        >
      </p>
      <div class="evaluation-input-calificado-wrapper">
        <!-- <label class="evaluation-calificado-lbl" for="evaluation-calificado">
          <span class="txt-grad-azul txt-bold">Nombre del evaluado</span>
          <input
            type="text"
            id="evaluation-calificado"
            class="evaluation-calificado-input"
            :class="{ 'evaluation-invalid-input': errors.calificado }"
            v-model="frmCalificacion.calificado"
            @blur="validateCalificado"
            ref="evaluationCalificado"
            list="evaluationCalificadoList"
          />
          <datalist id="evaluationCalificadoList">
            <option
              v-for="(calificado, index) in calificados"
              :value="calificado.calificado"
              :key="index"
            >
              {{ calificado.calificado }}
            </option>
          </datalist>
          <p
            class="evaluation-invalid-feedback txt-bold"
            v-if="errors.calificado"
          >
            {{ errors.calificado }}
          </p>
        </label> -->

        <label class="evaluation-calificado-lbl" for="evaluation-calificado">
          <span class="txt-grad-azul txt-bold">Nombre del evaluado</span>
          <input
            type="text"
            name="evaluation-calificado"
            id="evaluation-calificado"
            class="evaluation-calificado-input"
            :class="{ 'evaluation-invalid-input': errors.calificado }"
            v-model="frmCalificacion.calificado"
            @keyup="validateCalificado"
            ref="evaluationCalificado"
          />
          <p
            class="evaluation-invalid-feedback txt-bold"
            v-if="errors.calificado"
          >
            {{ errors.calificado }}
          </p>
        </label>
      </div>
      <div class="evaluation-input-wrapper">
        <div
          class="evaluation-input-group"
          v-for="(moment, index) in intMomentos"
          :key="index"
        >
          <p class="evaluation-input-title txt-grad-azul txt-bold">
            {{ frmPlantilla.arrayMomentos[index] }}
          </p>
          <label
            class="evaluation-moment-label"
            :for="`evaluation-moment-input-${index}`"
            >Peso #{{ moment }}</label
          >
          <div class="evaluation-moment-input-div txt-bold">
            {{ frmPlantilla.arrayPorcentajes[index] }}%
          </div>
          <!-- <input type="number" class="evaluation-moment-input txt-bold" :id="`evaluation-moment-input-${index}`" v-model="frmPlantilla.arrayPorcentajes[index]" readonly disabled/> -->
          <label
            class="evaluation-value-label"
            :for="`evaluation-value-input-${index}`"
            >Valoración #{{ moment }}</label
          >
          <input
            type="number"
            step="any"
            min="0"
            max="5"
            class="evaluation-value-input"
            :id="`evaluation-value-input-${index}`"
            v-model="frmPlantilla.arrayValoraciones[index]"
            required
            @keyup="validateValoracion($event)"
          />
        </div>
      </div>
      <p
        class="evaluation-invalid-feedback txt-bold"
        ref="evaluationFeedback"
      ></p>
      <div class="evaluation-btn-wrapper">
        <button
          type="submit"
          class="evaluation-grad-btn"
          id="btnValorar"
          :disabled="result.show || result.loading"
        >
          <span class="txt-bold">
            <div class="lds-ring" v-if="result.loading">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
            {{ result.loading ? "Valorando..." : "Valorar" }}</span
          >
        </button>
        <!-- <button class="evaluation-normal-btn txt-bold" type="button">Atrás</button> -->
      </div>
    </form>
    <div
      class="evaluation-result-wrapper"
      v-if="result.show"
      ref="evaluationResult"
    >
      <p class="evaluation-result-title txt-bold txt-grad-color-2">
        Resultado Final
      </p>
      <p class="evaluation-result-txt">
        Su valoración con inteligencia artificial es
        <span class="txt-grad-color-2 txt-bold">{{
          Number(result.value).toFixed(2)
        }}</span>
        en un rango
        <span class="txt-grad-color-2 txt-bold">{{ result.valueRange }}</span>
      </p>

      <p class="evaluation-result-subtitle">
        Con valoración tradicional es
        <span class="evaluation-result-txt-hl txt-bold">{{
          Number(result.valueTraditional).toFixed(2)
        }}</span>
      </p>

      <div class="evaluation-result-graph-bg">
        <div class="evaluation-result-graph-lg">
          <RadarChart
            :dataProp="frmPlantilla.propValoraciones"
            :labelsProp="frmPlantilla.arrayMomentos"
          />
        </div>
      </div>
      <div class="evaluation-result-graph-bg">
        <div class="evaluation-result-graph">
          <LineChart
            :dataProp="frmPlantilla.propValoraciones"
            :labelsProp="frmPlantilla.arrayMomentos"
          />
        </div>
      </div>
      <div class="evaluation-result-btn-container">
        <button
          type="button"
          class="evaluation-normal-large-btn txt-bold"
          @click="getResetSection"
        >
          Evaluar con los mismos porcentajes
        </button>
        <button
          type="button"
          class="evaluation-grad-btn"
          @click="getFinishEvaluation"
        >
          <span class="txt-bold">Terminar</span>
        </button>
      </div>
      <!-- <div class="evaluation-result-graph-bg">
                <div class="evaluation-result-graph"></div>
            </div>
            <div class="evaluation-result-btn-container">
                <button type="button" class="evaluation-normal-large-btn txt-bold">Evaluar con los mismos porcentajes</button>
                <button type="button" class="evaluation-grad-btn"><span class="txt-bold">Terminar</span></button>
            </div> -->
    </div>

    <b-modal
      v-model="modalEvaluated.show"
      id="home-modal-delete"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header>
        <h5 class="modal-title">{{ modalEvaluated.title }}</h5>
        <button
          type="button"
          class="home-modal-delete-close-btn"
          @click="modalEvaluated.show = false"
        >
          <b-icon icon="x"></b-icon>
        </button>
      </template>

      <div class="home-modal-delete-body">
        <p class="home-modal-delete-txt" v-html="modalEvaluated.text"></p>
      </div>
      <template #modal-footer>
        <button
          type="button"
          class="home-modal-delete-normal-btn txt-bold"
          @click="handleCalificado('ver')"
        >
          {{ modalEvaluated.normalBtnText }}
        </button>

        <button
          type="button"
          class="home-modal-delete-grad-btn"
          @click="handleCalificado('actualizar')"
        >
          <span class="txt-bold">{{ modalEvaluated.gradBtnText }}</span>
        </button>
      </template>
    </b-modal>

    <b-modal
      v-model="modalEnd.show"
      id="home-modal-evaluate"
      size="lg"
      centered
      no-close-on-backdrop
      no-close-on-esc
    >
      <template #modal-header>
        <h5 class="modal-title">{{ modalEnd.title }}</h5>
        <button
          type="button"
          class="home-modal-evaluate-close-btn"
          @click="modalEnd.show = false"
        >
          <b-icon icon="x"></b-icon>
        </button>
      </template>
      <div class="home-modal-evaluate-body">
        <p class="home-modal-evaluate-txt" v-html="modalEnd.text"></p>
        <button
          type="button"
          class="home-modal-evaluate-excel-btn txt-bold"
          @click="getExportarExcel"
        >
          <b-icon
            class="home-modal-evaluate-excel-icon"
            icon="file-earmark-x"
          ></b-icon
          >Exportar Excel
        </button>
      </div>
      <template #modal-footer>
        <button
          type="button"
          class="home-modal-evaluate-normal-btn txt-bold"
          @click="modalEnd.show = false"
        >
          {{ modalEnd.normalBtnText }}
        </button>
        <button
          type="button"
          class="home-modal-evaluate-grad-btn"
          @click="goHome"
        >
          <span class="txt-bold">{{ modalEnd.gradBtnText }}</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import LineChart from "../Charts/LineChart.vue";
import RadarChart from "../Charts/RadarChart.vue";
//import MEC_Calificaciones_api from "@/modules/MEC_Calificaciones_api";
import MEC_Calificaciones_api from "../../modules/MEC_Calificaciones_api";
import MEC_Momentos_api from "@/modules/MEC_Momentos_api";

//@Hace referencia a toda la funcionalidad de vue, metodos y variables
var varSelf = null;

export default {
  components: { LineChart, RadarChart },
  data() {
    return {
      currentFocus: -1,
      errors: {},
      errorsFocus: [],
      frmPlantilla: {
        id_plantilla: 0,
        nombre_plantilla: "",
        numero_d_momentos: 0,
        //id_funcionario: 0,
        Id_institucion: 0,
        habilitado: 1,
        arrayPorcentajes: [],
        arrayValoraciones: [],
        propValoraciones: [],
        arrayMomentos: [],
      },
      frmCalificacion: {
        calificado: "",
        momento_nro: "",
        calificacion: 0,
        valor_tradicional: 0,
        mec_cuantitativo: 0,
        mec_cualitativo: "",
        habilitado: 1,
      },
      calificados: [],
      notasCalificadoAnterior: [],
      result: {
        loading: false,
        show: false,
        value: 0,
        valueRange: "",
        valueTraditional: 0,
      },
      modalEvaluated: {
        show: false,
        title: "Evaluar",
        text: "Esto es un texto de prueba",
        normalBtnText: "Cancelar",
        gradBtnText: "Aceptar",
        plantillaEliminar: {},
      },
      modalEnd: {
        loading: false,
        show: false,
        title: "¿Estás seguro de que deseas terminar de valorar?",
        text: "También puedes exportar tus valoraciones de esta sesión en un archivo de Excel:",
        normalBtnText: "Cancelar",
        gradBtnText: "Terminar",
      },
      chartData: {
        labels: [
          "Momento 1",
          "Momento 2",
          "Momento 3",
          "Momento 4",
          "Momento 5",
          "Momento 6",
        ],
        datasets: [
          {
            label: "",
            data: [3, 3, 4, 2, 1, 5],
            fill: true,
            backgroundColor: "#0cc2b761",
            borderColor: "#0cc2b7",
            pointBackgroundColor: "#1b5af861",
            pointBorderColor: "#0cc2b7",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "#0cc2b7",
          },
        ],
      },
    };
  },
  created() {
    varSelf = this;
  },
  computed: {
    intMomentos() {
      return Number(this.frmPlantilla.numero_d_momentos);
    },
  },
  watch: {
    // frmPlantilla: {
    //   handler() {
    //     for (let i = 0; i < this.intMomentos; i++) {
    //       this.frmPlantilla.arrayMomentos[i] =
    //         this.plantillaEvaluarProp.plantillaEvaluar.arrayMomentos[i];
    //     }
    //   },
    //   deep: true,
    // },
    // intMomentos() {
    //   console.log("cambia intMomentos");
    //   console.log(this.intMomentos);
    //   for (let i = 0; i < this.intMomentos; i++) {
    //     this.frmPlantilla.arrayMomentos[i] =
    //       this.plantillaEvaluarProp.plantillaEvaluar.arrayMomentos[i];
    //   }
    // },
  },

  props: { plantillaEvaluarProp: Object, id_funcionario: Number },

  mounted() {
    const self = this;

    document.addEventListener("click", function (e) {
      self.closeAllLists(undefined, e.target);
    });

    // console.log(this.plantillaEvaluarProp);

    if (typeof Object.keys(this.plantillaEvaluarProp) === "object") {
      this.getCalificados(
        this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla
      );
      this.getMomentos(this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla);
      this.frmPlantilla.id_plantilla =
        this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla;
      this.frmPlantilla.nombre_plantilla =
        this.plantillaEvaluarProp.plantillaEvaluar.nombre_plantilla;
      this.frmPlantilla.numero_d_momentos =
        this.plantillaEvaluarProp.plantillaEvaluar.numero_d_momentos;

      //   if (!this.plantillaEvaluarProp.plantillaEvaluar.arrayPorcentajes) {
      //   this.getMomentos(
      //     this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla
      //   );
      // } else {
      //   this.frmPlantilla.arrayPorcentajes =
      //     this.plantillaEvaluarProp.plantillaEvaluar.arrayPorcentajes;
      //   this.frmPlantilla.arrayMomentos =
      //     this.plantillaEvaluarProp.plantillaEvaluar.arrayMomentos;
      // }
    }
    // if (Object.keys(this.plantillaEvaluarProp).length > 0) {
    //     this.frmPlantilla.id_plantilla= this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla;
    //     this.frmPlantilla.nombre_plantilla= this.plantillaEvaluarProp.plantillaEvaluar.nombre_plantilla;
    //     this.frmPlantilla.numero_d_momentos=this.plantillaEvaluarProp.plantillaEvaluar.numero_d_momentos;
    //     this.frmPlantilla.arrayPorcentajes =this.plantillaEvaluarProp.plantillaEvaluar.arrayPorcentajes;
    // }
  },
  methods: {
    autocomplete(element, list) {
      let array = [];

      if (!list) {
        return;
      }

      list.forEach((e) => {
        array.push(e.calificado);
      });

      element.addEventListener("input", (e) => {
        let autocomplete,
          item,
          index,
          value = e.target.value;

        this.closeAllLists(e, element);

        if (!value) {
          return false;
        }

        this.currentFocus = -1;

        autocomplete = document.createElement("div");
        autocomplete.setAttribute("id", `${element.id}-autocomplete-list`);
        autocomplete.setAttribute("class", "evaluation-autocomplete-items");

        element.parentNode.appendChild(autocomplete);

        for (index = 0; index < array.length; index++) {
          if (
            array[index].substr(0, value.length).toUpperCase() ==
            value.toUpperCase()
          ) {
            item = document.createElement("div");

            item.innerHTML = `<strong>${array[index].substr(
              0,
              value.length
            )}</strong>${array[index].substr(value.length)}
            <input type='hidden' value='${array[index]}'>
            `;

            item.addEventListener("click", (eve) => {
              element.value = eve.target.getElementsByTagName("input")[0].value;
              this.frmCalificacion.calificado =
                eve.target.getElementsByTagName("input")[0].value;
              this.closeAllLists(undefined, element);
            });

            autocomplete.appendChild(item);
          }
        }
      });

      element.addEventListener("keydown", (e) => {
        let autocompleteKey = document.querySelector(
          `#${element.id}-autocomplete-list`
        );

        if (autocompleteKey) {
          autocompleteKey = autocompleteKey.getElementsByTagName("div");
        }

        if (e.keyCode == 40) {
          this.currentFocus++;
          this.addActive(autocompleteKey);
        } else if (e.keyCode == 38) {
          this.currentFocus--;
          this.addActive(autocompleteKey);
        } else if (e.keyCode == 13) {
          e.preventDefault();
          if (this.currentFocus > -1) {
            if (autocompleteKey) autocompleteKey[this.currentFocus].click();
          }
        }
      });
    },

    addActive(elements) {
      if (!elements) {
        return false;
      }

      this.removeActive(elements);

      if (this.currentFocus >= elements.length) {
        this.currentFocus = 0;
      }

      if (this.currentFocus < 0) {
        this.currentFocus = elements.length - 1;
      }

      elements[this.currentFocus].classList.add(
        "evaluation-autocomplete-active"
      );
    },

    removeActive(elements) {
      for (let i = 0; i < elements.length; i++) {
        elements[i].classList.remove("evaluation-autocomplete-active");
      }
    },

    closeAllLists(element, input) {
      const lists = document.querySelectorAll(".evaluation-autocomplete-items");

      for (let i = 0; i < lists.length; i++) {
        if (element != lists[i] && element != input) {
          lists[i].parentNode.removeChild(lists[i]);
        }

        return element;
      }
    },

    async evaluateForm() {
      // this.result.value = this.frmPlantilla.arrayValoraciones.reduce(
      //   (acumulado, valorActual) => {
      //     console.log(acumulado);
      //     return Number(acumulado) + Number(valorActual);
      //   }
      // );
      if (!this.validateForm()) {
        return;
      }

      this.result.loading = true;

      //#Cuando el formulario tiene todos los datos validos pasa por este bloque

      //##Inserta los datos de la calificacion
      await this.getInsCalificacion();
      //##

      this.result.value = 0;

      for (let i = 0; i < this.frmPlantilla.arrayValoraciones.length; i++) {
        this.result.value =
          this.result.value +
          Number(this.frmPlantilla.arrayValoraciones[i]) *
            Number(this.frmPlantilla.arrayPorcentajes[i]);
      }
      this.result.value = Number(this.result.value / 100).toFixed(2);

      if (this.result.value > 4) {
        this.result.valueRange = "ALTO";
      } else if (this.result.value > 3) {
        this.result.valueRange = "MEDIO";
      } else {
        this.result.valueRange = "BAJO";
      }

      this.frmPlantilla.propValoraciones = this.frmPlantilla.arrayValoraciones;

      this.result.show = true;
      this.$nextTick(() => {
        if (window.innerWidth < 600) {
          this.$emit("scrollTo", { top: 1200 });
        } else {
          this.$emit("scrollTo", { top: 900 });
        }
      });

      //#Carga la calificacion
      await this.getCalificarPlantilla();
      this.result.loading = false;

      //this.frmPlantilla.arrayValoraciones = [];
    },

    async confirmEvaluateForm() {
      const apiCalificaciones = new MEC_Calificaciones_api();
      this.notasCalificadoAnterior = [];
      this.result.loading = true;

      apiCalificaciones
        .calificado_plantilla_datos(
          this.frmPlantilla.id_plantilla,
          this.frmCalificacion.calificado
        )
        .then((result) => {
          // console.log(result.data.result);
          this.result.loading = false;

          if (result.data.result.length > 0) {
            result.data.result.forEach((e) => {
              this.notasCalificadoAnterior.push(e.calificacion);
            });

            this.modalEvaluated.title = "Evaluar";
            this.modalEvaluated.text = `
                <span class="txt-bold">${this.frmCalificacion.calificado}</span> ya tiene las siguientes valoraciones: ${this.notasCalificadoAnterior}.
                <br/>
                <br/>
                <span class="txt-bold">¿Deseas actualizar esas notas o volver a ver su resultado?</span>
                `;
            this.modalEvaluated.gradBtnText = "Actualizar";
            this.modalEvaluated.normalBtnText = "Ver";
            this.modalEvaluated.show = true;
          } else {
            this.evaluateForm();
          }
        })
        .catch((err) => {
          this.result.loading = false;
          console.log(err);
        });
    },

    async handleCalificado(action) {
      const apiCalificaciones = new MEC_Calificaciones_api();

      if (action === "actualizar") {
        await apiCalificaciones
          .delete_calificado(
            this.frmPlantilla.id_plantilla,
            this.frmCalificacion.calificado
          )
          .then((result) => {
            console.log(result);
            this.modalEvaluated.show = false;
            this.evaluateForm();
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (action === "ver") {
        this.frmPlantilla.arrayValoraciones = this.notasCalificadoAnterior;

        await apiCalificaciones
          .delete_calificado(
            this.frmPlantilla.id_plantilla,
            this.frmCalificacion.calificado
          )
          .then((result) => {
            this.modalEvaluated.show = false;
            this.evaluateForm();
            return result;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    validateForm() {
      this.errors = {};
      this.errorsFocus = [];
      this.frmCalificacion.calificado = this.frmCalificacion.calificado.trim();
      this.validateCalificado();
      if (this.errorsFocus.length > 0) {
        this.focusInput(this.errorsFocus[0]);
      }
      return Object.keys(this.errors).length === 0;
    },
    validateValoracion(event) {
      event.target.classList.remove("evaluation-invalid-input");
      this.$refs.evaluationFeedback.textContent = "";
      if (!event.target.value) {
        this.$refs.evaluationFeedback.textContent =
          "No puedes dejar notas sin valorar";
        event.target.classList.add("evaluation-invalid-input");
      } else if (
        Number(event.target.value) > 5 ||
        Number(event.target.value) < 0
      ) {
        this.$refs.evaluationFeedback.textContent =
          "La nota valorada no puede ser mayor a 5 o menor que 0";
        event.target.classList.add("evaluation-invalid-input");
      } else {
        event.target.classList.remove("evaluation-invalid-input");
        this.$refs.evaluationFeedback.textContent = "";
      }
    },
    validateCalificado() {
      if (!this.frmCalificacion.calificado) {
        this.errors.calificado = "Debe digitar un calificado";
        this.errorsFocus.push("evaluationCalificado");
      } else {
        this.errors.calificado = "";
        delete this.errors.calificado;
      }
    },
    goHome() {
      this.$emit("sectionChange", { section: "home", lastSection: "creation" });
    },
    getResetSection() {
      this.frmCalificacion.calificado = "";
      this.frmPlantilla.arrayValoraciones = [];
      this.result.show = false;
      this.result.value = 0;
      this.getCalificados(
        this.plantillaEvaluarProp.plantillaEvaluar.id_plantilla
      );
    },
    getFinishEvaluation() {
      this.modalEnd.show = true;
    },
    async getInsCalificacion() {
      var api = new MEC_Calificaciones_api();

      var varContNotas = 0;
      for (var i = 0; i < this.intMomentos; i++) {
        if (
          document.getElementById("evaluation-value-input-" + i).value == ""
        ) {
          varContNotas = varContNotas + 1;
        }
      }
      if (varContNotas == 0) {
        var varfrmCalificacion = {};
        for (var j = 0; j < this.intMomentos; j++) {
          varfrmCalificacion = {
            id_plantilla: this.frmPlantilla.id_plantilla,
            calificado: this.frmCalificacion.calificado,
            momento_nro: j + 1,
            calificacion: parseFloat(
              document.getElementById("evaluation-value-input-" + j).value
            ),
            valor_tradicional: this.frmCalificacion.valor_tradicional,
            mec_cuantitativo: this.frmCalificacion.mec_cuantitativo,
            mec_cualitativo: this.frmCalificacion.mec_cualitativo,
            habilitado: 1,
          };
          await api
            .insert(varfrmCalificacion)
            .then(function (prmRes) {
              return prmRes;
            })
            .then(function (prmData) {
              // console.log(prmData);
              return prmData;
            });
        }
      }

      //ejecutar sp para calcular la nota
    },
    getMomentos(prmIdPlantilla) {
      var api = new MEC_Momentos_api();
      api
        .getIdPlantilla(prmIdPlantilla)
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          if (
            Array.isArray(prmData.data.result) &&
            prmData.data.result.length > 0
          ) {
            for (var i = 0; i < prmData.data.result.length; i++) {
              //varSelf.frmPlantilla.arrayPorcentajes.push({nom_momento: prmData.data.result[i].nombre_momento, peso_momento: prmData.data.result[i].peso_momento});
              varSelf.frmPlantilla.arrayPorcentajes.push(
                prmData.data.result[i].peso_momento
              );
              varSelf.frmPlantilla.arrayMomentos.push(
                prmData.data.result[i].nombre_momento
              );
            }
          }
        });
    },

    async getCalificados(id_plantilla) {
      const apiCalificaciones = new MEC_Calificaciones_api();

      await apiCalificaciones
        .calificados_plantilla(id_plantilla)
        .then((result) => {
          this.calificados = result.data.result;
          this.autocomplete(
            this.$refs.evaluationCalificado,
            result.data.result
          );
        })
        .catch((err) => {
          console.log(err);
        });
    },

    focusInput(inputRef) {
      this.$nextTick(() => {
        this.$refs[inputRef].focus();
      });
    },
    getCalificarPlantilla() {
      var api = new MEC_Calificaciones_api();
      api
        .calificar_plantilla(
          this.frmPlantilla.id_plantilla,
          this.frmCalificacion.calificado
        )
        .then(function (prmRes) {
          return prmRes;
        })
        .then(function (prmData) {
          // console.log(prmData);
          varSelf.result.valueRange = prmData.data.result.mec_cualitativo;
          varSelf.result.value = prmData.data.result.mec_cuantitativo;
          varSelf.result.valueTraditional =
            prmData.data.result.valor_tradicional;
        });
    },
    getExportarExcel() {
      var api = new MEC_Calificaciones_api();
      api.reporte_x_plantilla(this.frmPlantilla.id_plantilla);
    },

    //si le doy en el boton reiniciar borra lo que hay en calificaciones
  },
};
</script>

<style>
#evaluation-section-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.evaluation-section-title {
  font-size: 40px;
  color: var(--white);
  text-align: center;
}

.evaluation-gohome-container {
  width: 70%;
  margin: 50px auto 70px auto;
}

.evaluation-gohome-btn {
  all: unset;
  cursor: pointer;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
}

.evaluation-gohome-btn::after {
  content: "";
  position: absolute;
  bottom: -5px;
  width: 0px;
  height: 2px;
  transition: width 0.1s linear;
  background-image: var(--grad-color-2);
  border-radius: 4px;
}

.evaluation-gohome-btn:focus::after {
  width: 100%;
}

.evaluation-gohome-btn svg {
  transition: transform 0.3s ease-in-out;
}

.evaluation-gohome-btn:hover svg {
  transform: translateX(-10px);
}

.evaluation-section-form {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.evaluation-form-title {
  color: var(--white);
  text-align: center;
}

.evaluation-input-calificado-wrapper {
  width: 90%;
  align-self: center;
}

.evaluation-calificado-lbl {
  width: 100%;
  max-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
}

.evaluation-autocomplete-items {
  position: absolute;
  border: 1px solid var(--input-border);
  border-bottom: none;
  border-top: none;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 300px;
  overflow-y: auto;
}

.evaluation-autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: var(--input-bg);
  border-bottom: 1px solid var(--input-border);
  color: var(--white);
}

.evaluation-autocomplete-active,
.evaluation-autocomplete-items div:hover {
  background-color: var(--accent-color) !important;
  color: var(--white) !important;
}

.evaluation-calificado-input {
  padding: 0 1rem;
  outline: none;
  border: none;
  width: 100%;
  height: 48px;
  border-radius: 10px;
}

.evaluation-input-wrapper {
  margin: 40px auto;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 50px;
}

.evaluation-input-wrapper + .evaluation-invalid-feedback {
  margin-bottom: 2rem;
}

.evaluation-input-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.evaluation-input-title {
  margin: 0;
}

.evaluation-moment-label,
.evaluation-value-label {
  color: var(--white);
}

.evaluation-moment-input,
.evaluation-value-input {
  border: none;
  outline: none;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
}

.evaluation-calificado-input:focus,
.evaluation-value-input:focus {
  border: 1px solid var(--accent-color);
  box-shadow: 0 0 0.5rem 1px #49fffcbc;
}

.evaluation-moment-input:disabled {
  background-image: var(--grad-color-2);
  color: var(--black);
}

.evaluation-moment-input-div {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: var(--grad-color-2);
  color: var(--black);
}

.evaluation-invalid-feedback {
  margin: 0 auto;
  color: red;
  font-size: 14px;
  width: 100%;
  max-width: 300px;
  text-align: center;
}

.evaluation-invalid-input {
  border: 1px solid red;
}

.evaluation-invalid-input:focus {
  border: 1px solid red;
  box-shadow: 0 0 1rem 5px #ff5c5cbc;
}

.evaluation-btn-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.evaluation-grad-btn {
  cursor: pointer;
  border: none;
  width: 150px;
  height: 48px;
  background-image: var(--grad-color-2);
  padding: 2px;
  border-radius: 15px;
}

.evaluation-grad-btn span {
  width: 100%;
  height: 100%;
  outline: none;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  color: var(--white);
  background-color: var(--black);
  transition: background 0.3s ease-in-out;
}

.evaluation-grad-btn span .lds-ring div {
  border: 4px solid var(--input-border);
  border-color: var(--input-border) transparent transparent transparent;
}

.evaluation-grad-btn:hover span {
  background-color: transparent;
}

.evaluation-grad-btn:disabled {
  background-image: none;
  background-color: var(--input-border);
  cursor: not-allowed;
}

.evaluation-grad-btn:disabled span {
  color: var(--input-border);
}

.evaluation-grad-btn:disabled:hover span {
  background-color: var(--black);
}

.evaluation-normal-btn {
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  width: 150px;
  height: 48px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  transition: color 0.3s ease-in-out;
}

.evaluation-normal-btn:hover {
  color: var(--hover-white);
}

.evaluation-grad-btn:focus,
.evaluation-normal-btn:focus {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}

.evaluation-result-wrapper {
  margin-top: 150px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.evaluation-result-title {
  margin: 0;
  font-size: 40px;
  text-align: center;
}

.evaluation-result-txt {
  margin: 0;
  font-size: 30px;
  color: var(--white);
  text-align: center;
}

.evaluation-result-subtitle {
  margin: 0;
  font-size: 25px;
  color: var(--white);
  text-align: center;
}

.evaluation-result-txt-hl {
  color: var(--accent-color);
}

.evaluation-result-graph-bg {
  margin: 0 auto;
  background-image: var(--grad-color-2);
  padding: 2px;
  width: 80%;
  border-radius: 20px;
}

.evaluation-result-graph {
  width: 100%;
  height: 100%;
  min-height: 350px;
  background-color: var(--black);
  border-radius: 18px;
  padding: 1rem 2rem;
}

.evaluation-result-graph-lg {
  width: 100%;
  height: 100%;
  min-height: 550px;
  background-color: var(--black);
  border-radius: 18px;
  padding: 1rem 2rem;
}

.evaluation-result-btn-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.evaluation-normal-large-btn {
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  width: fit-content;
  padding: 0 1rem;
  min-height: 48px;
  border-radius: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  transition: color 0.3s ease-in-out;
  text-decoration: underline;
}

.evaluation-normal-large-btn:hover {
  color: var(--hover-white);
}

.evaluation-normal-large-btn:focus {
  outline: 2px solid var(--white);
  outline-offset: 2px;
}
</style>
